import { ListService, PagedResultDto } from '@abp/ng.core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetDetailsDto } from '@proxy/register-service/assets';
import { EventTypeDefinition } from '@proxy/servicing-service/inspection-types';
import {
  GetInspectionsInput,
  InspectionDetailsDto,
  InspectionState,
} from '@proxy/servicing-service/inspections';
import { InspectionService } from '@proxy/servicing-service/inspections/inspection.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-current-events-modal',
  templateUrl: './current-events-modal.component.html',
  styleUrls: ['./current-events-modal.component.scss'],
})
export class CurrentEventsModalComponent {
  @Input() openModal: boolean;
  @Input() asset: AssetDetailsDto;
  @Output() modalClose = new EventEmitter<boolean>();
}
